import React from 'react'
import Slider from 'rc-slider'

import { Props } from './types'

import {
  Output,
  Wrapper,
} from './styles'

const RangeSlider: React.FC<Props> = ({
  onChange,
  marks,
  min,
  max,
  outputLabel,
  value,
  ...props
}): React.ReactElement => (
  <Wrapper>
    <Slider
      {...props}
      min={min}
      max={max}
      step={null}
      dots={false}
      marks={marks}
      value={value as number}
      onChange={(value: number) => onChange(value)}
    />
    <Output>
      {value}
      {(outputLabel && ` ${outputLabel}`) || ''}
    </Output>
  </Wrapper>
)

export default RangeSlider
